import React, { useState } from 'react'
import { toDateTimeLocal } from '../utils';

export function DateTimeSelector({ disabled, onChange }) {
  const [displayDate, setDisplayDate] = useState(toDateTimeLocal(new Date()))
  return <form className='form'>
    <h5>Due date</h5>
    <input
      disabled={disabled}
      style={{ maxWidth: '180px' }}
      className='form-control'
      type='datetime-local'
      value={displayDate}
      onChange={e => {
        const value = e.target.value;
        setDisplayDate(value);
        onChange(new Date(value))
      }}
    ></input>
  </form>
}

export function OffsetSelector({ disabled, onChange }) {
  const [displayOffsetValues, setDisplayOffsetValues] = useState({ weeks: 0, days: 0, hours: 0, minutes: 0 })
  return <form>
    <h5>Offset</h5>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div>
        <span>Weeks:</span>
        <input
          disabled={disabled}
          style={{ maxWidth: '180px' }}
          className='form-control'
          type='number'
          value={displayOffsetValues.weeks}
          onChange={(e) => {
            const value = e.target.value
            setDisplayOffsetValues(prev => {
              return { ...prev, weeks: value }
            })
            onChange('weeks', value)
          }}
        ></input>
      </div>
      <div>
        <span>Days:</span>
        <input
          disabled={disabled}
          style={{ maxWidth: '180px' }}
          className='form-control'
          type='number'
          value={displayOffsetValues.days}
          onChange={(e) => {
            const value = e.target.value
            setDisplayOffsetValues(prev => {
              return { ...prev, days: value }
            })
            onChange('days', value)
          }}
        ></input>
      </div>
      <div>
        <span>Hours:</span>
        <input
          disabled={disabled}
          style={{ maxWidth: '180px' }}
          className='form-control'
          type='number'
          value={displayOffsetValues.hours}
          onChange={(e) => {
            const value = e.target.value
            setDisplayOffsetValues(prev => {
              return { ...prev, hours: value }
            })
            onChange('hours', value)
          }}
        ></input>
      </div>
      <div>
        <span>Minutes:</span>
        <input
          disabled={disabled}
          style={{ maxWidth: '180px' }}
          className='form-control'
          type='number'
          value={displayOffsetValues.minutes}
          onChange={(e) => {
            const value = e.target.value
            setDisplayOffsetValues(prev => {
              return { ...prev, minutes: value }
            })
            onChange('minutes', value)
          }}
        ></input>
      </div>
    </div>
  </form>
}

